import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/refinancia/Refinancia.svg'
import _imports_1 from '@/assets/img/home.svg'
import _imports_2 from '@/assets/img/dollar-sign.svg'
import _imports_3 from '@/assets/img/help.svg'
import _imports_4 from '@/assets/img/log-out.svg'


const _withScopeId = n => (_pushScopeId("data-v-1903ef11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = { class: "sidebar__dataprofile" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dataprofile-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "dataprofile-text" }
const _hoisted_5 = { class: "user-name" }
const _hoisted_6 = { class: "sidebar__menu" }
const _hoisted_7 = { class: "sidebar__menu-top" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sidebar-icon",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "sidebar-label" }, "Inicio", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sidebar-icon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "sidebar-label" }, "Consultar pagos", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sidebar__menu-link" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "sidebar-icon",
    src: _imports_3,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("h4", {
    id: "modalHelp",
    class: "sidebar-label"
  }, "Canales de atención")
], -1))
const _hoisted_14 = { class: "sidebar__menu-bottom" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "sidebar-icon",
  src: _imports_4,
  alt: ""
}, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "sidebar-label" }, "Salida segura", -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalCustomerServiceChannels = _resolveComponent("ModalCustomerServiceChannels")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.userData?.name), 1)
        ])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "sidebar__menu-link",
              onClick: _withModifiers(_ctx.changeComponent, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          (_ctx.isLinceUser)
            ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: "/payment",
                  class: "sidebar__menu-link"
                }, {
                  default: _withCtx(() => [
                    _hoisted_11,
                    _hoisted_12
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openModalHelp && _ctx.openModalHelp(...args)), ["prevent"]))
          }, [
            _hoisted_13,
            (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
              _createVNode(_component_ModalCustomerServiceChannels, {
                "is-visible": _ctx.showModalHelp,
                onCancel: _ctx.closeModal
              }, null, 8, ["is-visible", "onCancel"])
            ]))
          ])
        ]),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              class: "sidebar__menu-link",
              href: "javascript:(void)",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
            }, _hoisted_17)
          ])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_component_ModalCustomerServiceChannels, {
        "is-visible": _ctx.showModalHelp,
        onCancel: _ctx.closeModal
      }, null, 8, ["is-visible", "onCancel"])
    ]))
  ], 64))
}